<template>
	<div class="card messenger">

        <div class="card-header justify-content-between border-bottom pb-3">

            <span class="h6">
               {{$t('account/missions.Messenger')}}
            </span>

        </div> 
        <!-- /.card-header -->

        <div class="card-body" ref="body">

            <div v-if="loading" key="loading">
				<div class="text-center my-3">
					<loader small></loader>
				</div>
			</div>

			<transition name="slide-fade">
				<div v-if="!loading && !messages.length">
					<h5 class="text-center my-5 mb-6">
						{{$t('account/missions.Empty messages')}}
					</h5>
				</div>
			</transition>

			<div 
			ref="messages" 
			class="messenger-messages">
				<transition-group name="slide-up">
					<div 
					:key="'message-'+message.id"
					v-for="message in messages"
					class="comment mb-3"
					v-if="message.author_type != 'platforms'"
					:class="{'comment-reverse': message.author.id == account}">

						<div class="row">

							<!-- <div class="col-auto">
								<div class="avatar avatar-xs">
									<span class="avatar-title rounded-circle">
										{{message.author.initials}}
									</span>
								</div>
							</div> -->

							<div class="col ml-n2">

								<div class="comment-body">

									<div class="row comment-header">
							      
										<div class="col">
											<h5 class="comment-title">
												{{message.author.fullname}}
											</h5>
										</div> 

										<div class="col-auto">
											<time class="comment-time">
												{{message.created_at|dateFromNow}}
											</time>
										</div>

							    	</div> <!-- / .row -->

									<!-- Text -->
									<nl2br 
									tag="p" 
									v-if="message.content"
									class="comment-text my-2" 
									:text="message.content" />

									<messenger-medias
									v-if="message.medias"
									:medias="message.medias" />

							  	</div> <!-- /.comment-body -->

							</div> <!-- /.col -->

						</div> <!-- /.row -->

					</div> <!-- /.comment -->
				</transition-group>
			</div>

        </div> <!-- /.card-body -->

        <transition name="slide-fade">	

			<div v-if="!loading" class="card-footer">

				<div
				class="dropzone-container"
				@dragover="dragover"
				@dragleave="dragleave"
				@drop="drop">

					<div 
					class="p-4 dropzone"
					v-if="isDragging">
						<i class="fe fe-camera me-3"></i>
						{{trans('app.Drop your pictures here')}}
					</div>
			
					<textarea
					v-else
					ref="message" 
					class="form-control"
					@keydown.enter.exact.prevent="sendMessage"
					v-model="message"></textarea>

					<input 
					ref="files"
					class="d-none"
					type="file" 
					@change="setFiles"
					multiple />

					<transition name="slide-down">
						<div v-if="errors.length" class="alert alert-light mt-2 mb-3" role="alert">
					        <small>{{ errors[0] }}</small>
					    </div>
					</transition>

				</div> <!-- /.dropzone-container -->

				<div class="d-flex justify-content-end mt-4">

					<loading-button 
					@click="$refs.files.click()"
					:loading="uploading"
					theme="outline-primary"
					class="mr-3">
						<i class="fe fe-file mr-3"></i>
						{{$t('app.Attach files')}}
					</loading-button>

					<loading-button 
					@click="sendMessage"
					:disabled="isEmpty()" 
					:loading="sending"
					class="btn btn-primary">
						{{$t('app.Send')}}
					</loading-button>

				</div>

			</div>

		</transition>
        

    </div>  <!-- /.card -->
</template>

<script>
	export default {

		props: {

            type: String,

			model: {
				type: [String, Number],
				default: null
			},

			account: {
				type: [String, Number],
				default: null
			},

			data: {
				type: Object,
				default: () => {}
			},
		},

		data() {
			return {
				loading: true,
				sending: false,
				uploading: false,
				files: null,
				isDragging: false,
				message: '',
				errors: {},
				conversation: {}
			}
		},

		computed: {

			messages() {
				return this.conversation.messages
			}
		},

		methods: {

			isEmpty() {
				return _.isObject(this.message) 
				? !this.message.blocks.length 
				: !this.message
			},

			loadConversation(scrollToBottom = true) {

				return new Promise((resolve, reject) => {

					axios.post(`/account/${this.type}/${this.model}/conversation`)
					.then(response => {
						
						this.conversation = response.data
						resolve(response.data)
						
						if(scrollToBottom) 
						{
							this.scrollToBottom()
						}

					}).catch(error => {
						reject(error.response)
					})
				})

			},

			scrollToBottom() {
				setTimeout(() => {

					var $body = this.$refs.body
					$body.scrollTop = $body.scrollHeight

				}, 100)
			},

			sendMessage() {

				this.sending = true;
 
				var formData = new FormData() 
				formData.append('message', this.message || " ") 

				if(this.files)
				{
					for(let i = 0; i < this.files.length; i++) 
					{
						formData.append('files[]', this.files[i]);
					}
				}

				axios.post(`/account/${this.type}/${this.model}/message`, formData
				).then(response => {

					this.loadConversation()
					.then(() => {
						this.sending = false
						this.uploading = false
						this.files = null
						this.errors = {}
						this.message = null

						this.scrollToBottom()
					})

				}).catch(error => {
					this.sending = false
					this.uploading = false
					this.files = null
					this.errors = _.first(_.toArray(error.response.data.errors))
					this.$flash(this.$t('app.An error has occured'))
				})

			},

			dragover(e) {
				e.preventDefault();
				this.isDragging = true;
		    },

		    dragleave() {
				this.isDragging = false;
		    },

		    drop(e) {
				e.preventDefault();
				this.isDragging = false;
				this.files = e.dataTransfer.files
				this.upload()
		    },

		    setFiles(e) {
		    	this.files = e.target.files
		    	this.upload()
		    },

		    upload() {
		    	this.uploading = true
		    	this.sendMessage()
		    }

		},

		mounted() {
			this.loading = true

			this.loadConversation()
			.then(() => { 
				this.loading = false 
				this.scrollToBottom()
			})

			this.$store.commit('lang/setActive', true)
			this.$store.commit('lang/setLangs', this.data.langs)
			window.i18n.locale = this.data.locale
			window.moment.locale(this.data.locale)

			setInterval(() => {
				this.loadConversation(false)
			}, 10000)
		},



	}
</script>